import {Directive, HostBinding} from '@angular/core'

@Directive({ 
    selector: '[show-hide-input]'
})
export class ShowHideInput
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}

@Directive({ 
    selector: '[show-hide-input2]'
})
export class ShowHideInput2
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}

@Directive({ 
    selector: '[show-hide-input3]'
})
export class ShowHideInput3
{
    @HostBinding() type: string;
     
    constructor(){
        this.type='password';
    }
    
    changeType(type:string): void {
        this.type = type;
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/login/show-hide-input.directive.ts